<div class="error-page">
    <div [ngSwitch]="errorType">
        <div *ngSwitchCase="'cookie-configuration'">
            <h3 >3rd Party Cookies Required</h3>
            <p >It looks like your browser's security settings could be preventing 3rd party cookies and storage, which Alert Logic relies upon to provide authentication across all of our applications.  Please change your browser settings and try again.</p>
            <p >Please reference <a href="https://support.alertlogic.com/hc/en-us/articles/360029486612-Why-do-I-need-to-enable-third-party-cookies-to-log-into-the-Alert-Logic-console-" target="_blank">this knowledge base article</a> for more information.</p>
        </div>
        <div *ngSwitchDefault>
            <h3 >General Error</h3>
        </div>
    </div>
</div>
